import { CSSProperties } from 'react';
import styled from 'styled-components';

interface INotificationContainerProps {
	$layerIndex?: number;
}

const getLayerScale = (layerIndex: number): number =>
	Math.max(0.8, 1 - layerIndex * 0.05);

const getLayerOpacity = (layerIndex: number): number =>
	layerIndex === 0 ? 1 : 0.2;

const getLayerOffset = (layerIndex: number): number => -layerIndex * 50;

const NotificationContainer = styled.div.attrs<INotificationContainerProps>(
	({ $layerIndex = 0 }) => ({
		style: {
			'--layer-offset': `${getLayerOffset($layerIndex)}px`,
			'--layer-scale': `${getLayerScale($layerIndex)}`,
			'--layer-opacity': `${getLayerOpacity($layerIndex)}`,
			zIndex: 500 - $layerIndex,
		} as CSSProperties,
	}),
)<INotificationContainerProps>`
	position: absolute;
	left: 50%;
	bottom: 40px;
	transform: translate(-50%, var(--layer-offset, 0px))
		scale(var(--layer-scale, 1));
	display: flex;
	align-items: center;
	column-gap: 10px;
	padding: 0 10px;
	height: 40px;
	border-radius: 10px;
	overflow: hidden;
	user-select: none;
	pointer-events: none;
	opacity: var(--layer-opacity, 1);
	transition:
		transform 0.3s ease,
		opacity 0.3s ease,
		bottom 0.3s ease,
		background-color 0.3s ease;

	&.fade-enter {
		opacity: 0;
		transform: translate(-50%, calc(220% + var(--layer-offset, 0px)))
			scale(var(--layer-scale, 1));
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: var(--layer-opacity, 1);
		transform: translate(-50%, var(--layer-offset, 0px))
			scale(var(--layer-scale, 1));
	}

	&.fade-exit-active {
		opacity: 0;
		transform: translate(-50%, calc(220% + var(--layer-offset, 0px)))
			scale(var(--layer-scale, 1));
	}

	img {
		user-select: none;
	}
`;

export { NotificationContainer };
